import { createFileRoute } from '@tanstack/react-router'
import { Archive } from 'lucide-react'
import { z } from 'zod'
import { CompactionScreen } from '@/screens/engine/SCR-012-compaction'

export const Route = createFileRoute('/_app/w/$ws/compaction')({
  staticData: { screen: { id: 'SCR-012', title: 'Compaction', group: 'Workspace', perm: 'projection.manage', order: 12, eyebrow: 'Merge and retire, with history', description: 'Merge duplicates and retire unused memory. A dry run shows exactly what changes; nothing is deleted.', icon: Archive } },
  validateSearch: z.object({
    run: z.string().max(100).optional().catch(undefined),
  }),
  component: CompactionScreen,
})
